import * as yup from 'yup';

function repairCategory(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'REPAIR_CATEGORY_IS_REQUIRED',
        defaultMessage: 'Repair Category is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'CREATEFORM_REPAIRSEVERITY_FIELD_MAX_CHARS_64',
        defaultMessage: 'Repair Category should be less than 64 chars',
      }),
    );
}

function repairCategoryCode(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'REPAIR_CATEGORY_CODE_IS_REQUIRED',
        defaultMessage: 'Repair Category Code is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_REPAIRSEVERITYCODE_FIELD_MAX_CHARS_32',
        defaultMessage: 'Repair Category Code should be less than 32 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      repairCategory: repairCategory(formatMessage),
      repairCategoryCode: repairCategoryCode(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
